export const VEHICLE_REGISTRATION_REGEX = /^[a-zA-Z0-9 ]{1,8}$/;

export const NAME_REGEX = /^[a-zA-Z](?:[ '.\-a-zA-Z]*[a-zA-Z])?$/;

export const PHONE_NUMBER_REGEX = /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/;

export const POSTALCODE_REGEX = /^([A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}|BFPO\d{1,4}|GIR0AA)$/i;

export const ALPHANUMERIC_REGEX = /^[a-zA-Z-]+$/;

export const PHONE_REGEX = /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/;

export const SORT_CODE_REGEX = /^(?!(?:0{6}|00-00-00))(\d{6}|(\d{2}-){2}\d{2})$/;

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/;

export const POLICY_NUMBER_REGEX = /^(?!\s*$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9'/_-]{7,}$/;
